import React, { useEffect } from "react";
import { ThemeProvider } from "styled-components";
import theme from "@/common/globalVariables";
// import App from "next/app";
import * as Sentry from "@sentry/react";
import { ApolloProvider } from "@apollo/client";
import { useApollo } from "@/lib/apolloClient";
import "./app.css";

import Page from "@/components/Page";
import "jodit/build/jodit.min.css";
import "semantic-ui-css/semantic.min.css";
import "./app.css";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DNS,
    ignoreErrors: [
      "ResizeObserver loop completed with undelivered notifications",
      "ResizeObserver loop limit exceeded",
      "Can't find variable: SCDynimacBridge",
      // Injected scripts (translation extensions etc.) call a minified
      // i18n.detectLanguage; this app ships no i18n library.
      "detectLanguage is not a function",
      // Next.js router fallback noise: a failed route-data fetch (e.g. stale
      // buildId after a deploy) hard-navigates to a URL the user is already on.
      "Invariant: attempted to hard navigate to the same URL",
    ],
    // Stack overflows reported here have no /_next/ frames — they come from
    // scripts injected into the page (e.g. Google iOS app's WKWebView), not
    // our bundles. Drop them; a real RangeError in our code keeps app frames.
    beforeSend(event) {
      const values = event.exception?.values ?? [];
      if (values.some((v) => v.type === "RangeError")) {
        const hasAppFrame = values.some((v) =>
          (v.stacktrace?.frames ?? []).some((f) =>
            f.filename?.includes("/_next/")
          )
        );
        if (!hasAppFrame) return null;
      }
      return event;
    },
  });
}

export default function App({ Component, pageProps, router }) {
  const apolloClient = useApollo(pageProps.initialApolloState);
  const isAdminLayout = isAdminPage(router.pathname);

  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={theme}>
        <Page admin={isAdminLayout}>
          <Component {...pageProps} />
        </Page>
      </ThemeProvider>
    </ApolloProvider>
  );
}
function isAdminPage(route) {
  return route.startsWith("/admin");
}
